import { render, staticRenderFns } from "./drawer-calls-list.vue?vue&type=template&id=58fd2ac9&scoped=true&"
import script from "./drawer-calls-list.vue?vue&type=script&lang=js&"
export * from "./drawer-calls-list.vue?vue&type=script&lang=js&"
import style0 from "./drawer-calls-list.vue?vue&type=style&index=0&id=58fd2ac9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd2ac9",
  null
  
)

export default component.exports